import i18n from "@/i18n"
import type { PreviewTabKey } from "@/stores/shot-panel-store"

export function animaticArtifactStatusText(status?: string, maxSeconds = 15): string {
  if (status === "ready") return i18n.t("shot:common.artifactReady")
  if (status === "processing") return i18n.t("shot:common.trimmingInProgress")
  if (status === "failed") return i18n.t("shot:common.trimFailed", { min: 2, max: maxSeconds })
  return i18n.t("shot:common.trimQueued")
}

export function mediaVersionKindTitle(kind: "storyboard" | "video" | "shooting_board", modal = false): string {
  if (kind === "storyboard") {
    return i18n.t(modal ? "shot:mediaVersions.storyboardModal" : "shot:mediaVersions.storyboard")
  }
  if (kind === "shooting_board") {
    return i18n.t(modal ? "shot:mediaVersions.shooting_boardModal" : "shot:mediaVersions.shooting_board")
  }
  return i18n.t("shot:mediaVersions.video")
}

export function generationLogStatusLabel(status: string): { label: string; cls: string } {
  const map: Record<
    string,
    {
      key:
        | "shot:mediaVersions.logStatus.sent"
        | "shot:mediaVersions.logStatus.succeeded"
        | "shot:mediaVersions.logStatus.failed"
      cls: string
    }
  > = {
    sent: { key: "shot:mediaVersions.logStatus.sent", cls: "text-blue-400" },
    succeeded: { key: "shot:mediaVersions.logStatus.succeeded", cls: "text-ui-status-approved" },
    failed: { key: "shot:mediaVersions.logStatus.failed", cls: "text-ui-status-failed" },
  }
  const row = map[status]
  if (row) return { label: i18n.t(row.key), cls: row.cls }
  return { label: status, cls: "text-ui-text-secondary" }
}

export function promptTabLabel(key: PreviewTabKey): string {
  const keys: Record<
    PreviewTabKey,
    | "shot:promptTabs.storyboard"
    | "shot:promptTabs.video"
    | "shot:promptTabs.shooting_board"
    | "shot:promptTabs.animatic"
    | "shot:promptTabs.previz"
  > = {
    storyboard: "shot:promptTabs.storyboard",
    video: "shot:promptTabs.video",
    shooting_board: "shot:promptTabs.shooting_board",
    animatic: "shot:promptTabs.animatic",
    previz: "shot:promptTabs.previz",
  }
  return i18n.t(keys[key])
}
